import React from "react";
import Form from "react-bootstrap/Form";
import PropTypes from "prop-types";
import { Spinner } from "react-bootstrap";

const _Select = (props) => {
  const {
    options = [],
    name,
    value,
    onChange,
    title,
    required,
    onBlur,
    isError,
    errors,
    disabled = false,
    loading = false,
    id = null,
  } = props;

  return (
    <div className="flex flex-col py-2 w-full">
      <label className="text-gray-700 font-semibold text-sm flex justify-start align-top mb-2">
        {title}
        {required && <span className="text-red-700 mx-1">*</span>}
      </label>
      {loading ? (
        <div className="border rounded px-3 py-2 flex items-center h-[38px] bg-gray-100 text-gray-500">
          <Spinner animation="border" size="sm" className="me-2" />
          Cargando...
        </div>
      ) : (
        <>
          <Form.Select
            id={id}
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            disabled={disabled}
            required={required}
            isInvalid={isError}
          >
            {options.map((item, index) => (
              <option key={index} value={item.value}>
                {item.label}
              </option>
            ))}
          </Form.Select>
          <Form.Control.Feedback type="invalid">{errors}</Form.Control.Feedback>
        </>
      )}
    </div>
  );
};

_Select.propTypes = {
  id: PropTypes.string,
  options: PropTypes.array,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  title: PropTypes.string,
  required: PropTypes.bool,
  isError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  errors: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
};

export default _Select;
